enum CareTaskPreferences {
  CareTasks = 'Careplans',
  TasksSummary = 'GET_PATIENT_TASKS_SUMMARY',
  TaskDetails = 'GET_TASK_FULL_DETAILS',
}

enum SessionPreferences {
  CreateSession = 'createSession',
  ExchangePubKey = 'ExchangePubKey',
  SessionValidity = 'SessionValidity',
  EndSession = 'EndSession',
}

enum DummyPatientPreferences {
  DummyPatient = 'dummyPatient',
  FillDummyPatientData = 'FillDummyPatientData',
  AddUUID = 'addPatientKeyId',
  AddTrustedSite = 'AddSiteToTrustedInstallation',
}

enum AccountPreferences {
  UserEmailExists = 'checkIfUserEmailExist',
  CreateAccount = 'createAccount',
  VerifyOTP = 'verifyPin',
  ResendPin = 'resendPin',
  DeleteAccount = 'SSORollback',
  Logout = 'Logout',
  CheckRegistrationInformation = 'CheckPatientRegistrationInformation',
}

enum ReminderPreferences {
  AnswerMedications = 'AnswerMedications',
  FetchReminders = 'Reminders',
  SendMedicationPlan = 'ProcessBMP',
  ArchiveMedicationPlan = 'ArchiveBMP',
  FetchMedicationPlanAsset = 'GetLatestMedicationPlan',
}

enum ProfilePreferences {
  GetInsuranceTypes = 'GetInsuranceTypes',
  GetPatientSettings = 'GetPatientSettings',
  UpdatePatientSettings = 'UpdatePatientSettings',
}

enum CareteamPreferences {
  RemoveSiteFromTrustedInstallation = 'removeSiteFromTrustedInstallation',
}

enum WearablesPreferences {
  SaveWithingsTokens = 'SaveWithingsTokens',
  GetWearableTokens = 'GetWearableTokens',
  WithingsRollBack = 'WithingsRollBack',
  GetWearablesData = 'WearablesData',
}

enum AssetPreferences {
  AssetRequest = 'assetRequest',
  GetAssets = 'getAssets',
}

enum StatsPreferences {
  SubmittedTasksData = 'GraphDataAndSubscores',
}

enum SocialMediaPreferences {
  Getlinks = 'GetSocialMediaLinks',
}

enum DevicePreferences {
  ResetNotifications = 'resetNotifications',
}

export const Preferences = {
  CareTask: CareTaskPreferences,
  Session: SessionPreferences,
  DummyPatient: DummyPatientPreferences,
  Account: AccountPreferences,
  Reminders: ReminderPreferences,
  Profile: ProfilePreferences,
  Careteam: CareteamPreferences,
  Wearables: WearablesPreferences,
  Asset: AssetPreferences,
  Stats: StatsPreferences,
  SocialMedia: SocialMediaPreferences,
  Device: DevicePreferences,
};

export type Preference =
  | CareTaskPreferences
  | SessionPreferences
  | DummyPatientPreferences
  | AccountPreferences
  | ReminderPreferences
  | ProfilePreferences
  | CareteamPreferences
  | WearablesPreferences
  | AssetPreferences
  | StatsPreferences
  | SocialMediaPreferences;
